<!-- 部门/成员选择器 -->
<template>
  <mk-select
    ref="select"
    v-model="memberNameList"
    class="dept-member-select"
    :width="width"
    multiple
    collapse-tags
    :placeholder="placeholder"
    popper-class="depart-member-mulitiple-select"
    @visible-change="visibleChange"
  >
    <mk-option
      label
      value
      disabled
    >
      <!-- multiple -->
      <dept-member
        ref="deptMember"
        :can-select-dept="canSelectDept"
        :init-dept-list="data.dept"
        :init-member-list="data.member"
        :is-single="isSingle"
        @cancel="cancelSelect"
        @confirm="confirmSelect"
      />
    </mk-option>
  </mk-select>
</template>
<script>
import deptMember from './component/dept-member/index'
export default {
  name: 'DeptMemberSelect',
  components: {
    deptMember
  },
  model: {
    prop: 'data',
    event: 'change'
  },
  props: {
    // 部门/成员数据
    data: {
      type: Object,
      default () {
        return {
          dept: [],
          member: []
        }
      }
    },
    // 部门是否可选（当isSingle为true时，部门必不可选）
    canSelectDept: {
      type: Boolean,
      default: true
    },
    // 是否为单选
    isSingle: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    width: {
      type: [String, Number],
      default: 420
    }
  },
  data () {
    return {
      memberNameList: [] // 成员名字数组
    }
  },
  created () {
    this.handlePropsData()
    this.getMemberNameList()
  },
  methods: {
    getMemberNameList () {
      let arr = this.data.dept.concat(this.data.member)
      let memberNameList = []
      arr.forEach(item => {
        memberNameList.push(item.name)
      })
      this.memberNameList = memberNameList
    },
    handlePropsData () {
      this.data.member.forEach(item => {
        item.userId = item.id
      })
    },
    confirmSelect (data) {
      this.$refs.select.$children[0].blur()
      // 处理select选中结果
      let memberNameList = []
      let arr = data.dept.concat(data.member)
      arr.forEach(item => {
        memberNameList.push(item.name)
      })
      this.memberNameList = memberNameList
      // v-model绑定值
      this.$emit('change', {
        dept: data.dept,
        member: data.member
      })
    },
    cancelSelect () {
      this.$refs.select.$children[0].blur()
    },
    visibleChange (state) {
      this.$emit('optionVisibleChange', state)
      this.$refs.deptMember.updateData(state)
    }
  }
}
</script>
<style lang="scss">
.depart-member-mulitiple-select {
  height: 386px;

  /deep/ .el-scrollbar {
    width: calc(100% + 2px);
    height: 386px;
  }

  /deep/ .el-select-dropdown__list {
    padding: 0;
  }

  /deep/ .el-select-dropdown__wrap {
    height: 405px;
    max-height: inherit !important;
  }

  /deep/ .el-select-dropdown__item {
    padding: 0;
    height: 386px;
    max-height: inherit;
  }
}
</style>
<style lang="scss" scoped>
.dept-member-select {
  /deep/ .el-tag__close {
    display: none !important;
  }
}
</style>
